/* nono-basket.js – 8 Oct 2026 basket review. Vanilla, no deps.
   1) Sticky Add to basket bar on PDPs (mobile). 2) "Add" buttons for drawer pairings (re-renders the Dawn cart drawer).
   2026-10-10 basket incentives: 2) also serves the "Little extras" row on /cart (re-renders the cart sections in place),
   3) animates the spend-more bar fill from its previous width after each drawer / cart re-render. */
(() => {
  const money = (c) => { const f = (window.nonoTheme && window.nonoTheme.moneyFormat) || '£{{amount}}'; const n = (c / 100).toFixed(2); return f.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => (k === 'amount_no_decimals' ? String(Math.round(c / 100)) : k === 'amount_with_comma_separator' ? n.replace('.', ',') : n.replace(/\B(?=(\d{3})+(?!\d))/g, ','))); }; // QA 2026-10-11 (S6)

  /* ---------- 1. sticky ATC ---------- */
  document.querySelectorAll('.nono-satc').forEach((bar) => {
    const form = document.getElementById(bar.dataset.formId);
    if (!form) return;
    const real = form.querySelector('[name="add"]');
    const btn = bar.querySelector('.nono-satc__btn');
    const sizeEl = bar.querySelector('.nono-satc__size');
    const priceEl = bar.querySelector('.nono-satc__price');
    const mq = matchMedia('(max-width: 749px)');
    let past = false;

    const sync = () => {
      const show = mq.matches && past;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', String(!show));
      btn.tabIndex = show ? 0 : -1;
      document.body.classList.toggle('nono-satc-on', show);
    };
    // Scroll check (rAF-throttled) rather than IntersectionObserver: IO skips the change when a jump
    // goes straight from "below the fold" to "above the top" (both non-intersecting).
    if (real) {
      let ticking = false;
      const check = () => {
        ticking = false;
        const r = real.getBoundingClientRect();
        const now = r.bottom < 0 && r.height > 0;
        if (now !== past) { past = now; sync(); }
      };
      const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(check); } };
      addEventListener('scroll', onScroll, { passive: true });
      addEventListener('resize', onScroll, { passive: true });
      check();
    }
    mq.addEventListener('change', sync);

    const syncButton = () => {
      if (!real) return;
      btn.disabled = real.disabled;
      const label = real.querySelector('span');
      if (label) btn.textContent = label.textContent.trim().split(' · ')[0]; // 2026-10-10: the real button also carries the price; the bar shows it beside the title
    };
    if (real) new MutationObserver(syncButton).observe(real, { attributes: true, childList: true, subtree: true });

    btn.addEventListener('click', () => {
      if (btn.disabled) return;
      if (form.requestSubmit) form.requestSubmit(real || undefined);
      else if (real) real.click();
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') { // const globals aren't on window
      subscribe(PUB_SUB_EVENTS.variantChange, (ev) => {
        const d = ev && ev.data;
        if (!d || d.sectionId !== bar.dataset.sectionId || !d.variant) return;
        const v = d.variant;
        if (sizeEl) sizeEl.textContent = ((v.options && v.options.length > 1 ? v.title : v.option1) || v.title || '').split(' - ')[0].replace(/^(50)\s*cm\s*x\s*(70)\s*cm$/i, '50 × 70');
        if (priceEl) {
          // 2026-10-13: real compare-at strike + price (same markup as snippets/nono-sale-price.liquid)
          priceEl.innerHTML = v.compare_at_price > v.price && v.price > 0
            ? '<span class="nono-sp nono-sp--sale"><span class="visually-hidden">Regular price</span><s class="nono-sp__was">' + money(v.compare_at_price) + '</s> <span class="visually-hidden">Sale price</span><span class="nono-sp__now">' + money(v.price) + '</span></span>'
            : '<span class="nono-sp">' + money(v.price) + '</span>';
        }
        syncButton();
      });
    }
  });

  /* QA 2026-10-11 (S8): 2) "Little extras" adds and 3) the spend-more bar animation removed: their markup (nono-extras,
     nono-spend-bar) is no longer rendered anywhere, and 3) ran a body-wide MutationObserver on every page. */
})();
